import React, { useState } from 'react';
import SyllabusScheduleTable from './SyllabusScheduleTable';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';

export default function SyllabusUploadStep2({
  rows,
  onChange,
  onBack,
  onConfirm,
  loading,
  courseId,
  deliveryDay = 'Sunday',
  backLabel = 'Back',
  syllabusData,
}) {
  const [error, setError] = useState('');

  const hasNoRows = rows.length === 0;
  const hasInvalidRows = rows.some((row) => {
    const topic = row.topic || row.name || '';
    return !row.date || !topic || topic.trim() === '';
  });
  const isConfirmDisabled = loading || hasNoRows || hasInvalidRows;

  const handleConfirm = () => {
    // Validation: At least one row must be present
    if (hasNoRows) {
      setError('Please add at least one lecture week before confirming.');
      return;
    }

    // Validation: All rows must have both date and topic
    if (hasInvalidRows) {
      setError(
        'Please complete all rows with date and lecture topic before confirming.',
      );
      return;
    }

    setError('');
    onConfirm();
  };

  return (
    <div className="syllabus-step">
      <div className="main-con">
        <div className="modal-header">
          <div className="syllabus-step-title">
            Confirm your lecture schedule
          </div>
          <p className="syllabus-step-desc">
            {rows.length === 0
              ? 'Add lecture weeks with dates and topics.'
              : 'Review and edit any dates or topics before confirming.'}
          </p>
        </div>
        <div className="section-con">
          {error && <div className="syllabus-error mb-2">{error}</div>}
          <SyllabusScheduleTable
            rows={rows}
            onChange={onChange}
            courseId={courseId}
            deliveryDay={deliveryDay}
            syllabusData={syllabusData}
          />
        </div>

        <div className="syllabus-step-footer">
          <div />
          <div className="d-flex align-items-center" style={{ gap: '1rem' }}>
            <RectangularButton onClick={onBack}>{backLabel}</RectangularButton>
            <RectangularButton
              darkButton
              onClick={handleConfirm}
              disabled={isConfirmDisabled}
            >
              {loading ? 'Saving...' : 'Confirm schedule'}
            </RectangularButton>
          </div>
        </div>
      </div>
    </div>
  );
}
